window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-order-confirmation-list');
    if (!page) return;

    const csvRoute = page.dataset.csvRoute;

    $(function () {
        clearFilters();
        csvDownload();
        toggleFilters();

        function clearFilters() {
            $('#btn_filters_clear').on('click', function (e) {
                e.preventDefault();
                var form = $('#frm_order_confirmation');

                form.find("input[name='search_form[order_number]']").val('');
                form.find("select[name='search_form[order_status]']").val('');
                form.find("select[name='search_form[billing_month]']").val('');
                form.find("select[name='search_form[categories]']").val('');
                form.find("select[name='search_form[sales_type]']").val('');
                form.find("input[name='search_form[manufacturer]']").val('');
                form.find("input[name='search_form[product_name]']").val('');
                form.find("input[name='search_form[model_number]']").val('');
                form.find("input[name='search_form[delivery_address]']").val('');
                form.find("input[name='search_form[construction_info_address]']").val('');
                form.find("input[name='search_form[building_name]']").val('');
                form.find("input[name='search_form[room_number]']").val('');
                form.find("input[name='search_form[recycling_voucher_number]']").val('');
                form.find("select[name='search_form[sort]']").val('');

                var dateFields = [
                    'estimate_request_date_from', 'estimate_request_date_to',
                    'site_survey_scheduled_date_from', 'site_survey_scheduled_date_to',
                    'estimate_completed_date_from', 'estimate_completed_date_to',
                    'order_completed_date_from', 'order_completed_date_to',
                    'construction_scheduled_date_from', 'construction_scheduled_date_to',
                    'construction_completed_date_from', 'construction_completed_date_to',
                    'delivery_scheduled_date_from', 'delivery_scheduled_date_to',
                    'shipment_completed_date_from', 'shipment_completed_date_to',
                    'data_extraction_period_from', 'data_extraction_period_to'
                ];

                dateFields.forEach(function (field) {
                    var input = form.find("input[name='search_form[" + field + "]']");
                    input.val('');
                    if (input[0] && input[0]._flatpickr) {
                        input[0]._flatpickr.clear();
                    }
                });

                form.find("input[name='search_form[pending_case]']").prop('checked', false);
                form.find("input[name='search_form[exclude_canceled]']").prop('checked', false);
            });
        }

        function csvDownload() {
            $('#btn_csv_download').on('click', function (e) {
                e.preventDefault();
                var form = $('#frm_order_confirmation');
                var params = form.serialize();
                window.location.href = csvRoute + '?' + params;
            });
        }

        function toggleFilters() {
            $('#js-toggleBtn').on('click', function () {
                var btn = $(this);
                var target = btn.closest('.togglegroupVox').find('.toggletarget');
                var form = $('#frm_order_confirmation');

                btn.toggleClass('is-open');
                target.slideToggle(300);

                var isOpen = btn.hasClass('is-open');
                form.find("input[name='show']").val(isOpen ? 1 : 0);
            });
        }
    });
});
